<template>
	<div class="order-search-body">
		<div class="filters-box-row">
			<div class="filters-container">
				<div class="input-box">
					<el-select v-model="dateType" class="select-input" size='small'>
						<el-option :value="0" label="下单时间"></el-option>
						<el-option :value="1" label="期望到货时间"></el-option>
					</el-select>
					<el-date-picker
						@change="searchTime"
						v-model="dateValue"
						:clearable="false"
						:unlink-panels='true'
						:default-time="['00:00:00', '23:59:59']"
						class="time-input"
						size="small"
						type="datetimerange"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						format='yyyy-MM-dd HH:mm'
						value-format='yyyy-MM-dd HH:mm'>
					</el-date-picker>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>订单编号：</span>
					<el-input
						class="search-input"
						v-model="orderNumber"
						placeholder="请输入订单编号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>商品名称：</span>
					<el-input
						class="search-input"
						v-model="productName"
						placeholder="请输入商品名称"
						size="small"
						maxlength="50"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container" style="position:relative">
				<el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
					{{ collapse ? '展开' : '收起' }}
					<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:#AFB1B3;"/>
				</el-button>
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="clear">清空</el-button>
				<!-- <div class="batch-register-btn" @click="exportExcel">
					<i class="excel-icon export-excel-icon"/>
					<span>导出</span>
				</div>
				<div class="batch-register-btn" @click="printerEvent">
					<i class="el-icon-printer" style="font-size: 16px; margin-right: 2px;"/>
					<span>打印</span>
				</div> -->
			</div>
		</div>
		<div class="filters-box-row filters-box-row2">
			<div class="filters-container" v-show="!collapse">
				<div class="input-box">
					<span>订单来源：</span>
					<el-select v-model="ordersource" class="filter-input cancel-select" size='small'>
						<el-option value="-1" label="全部"></el-option>
						<el-option value="1" label="代客"></el-option>
						<el-option value="0" label="自主"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>客户类别：</span>
					<el-select v-model="customerCategoryId" class="filter-input" size='small'>
						<el-option value="0" label="全部"></el-option>
						<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span>客户名称：</span>
					<el-input
						class="search-input"
						v-model="customerName"
						placeholder="请输入客户名称"
						size="small"
						maxlength="20"
						@keyup.enter.native="search">
					</el-input>
				</div>
				<div class="input-box">
					<span>所属线路：</span>
					<!-- <el-input
						class="search-input"
						v-model="keyword"
						placeholder="请输入线路"
						size="small"
						@keyup.enter.native="search">
					</el-input> -->
					<el-select v-model="lineId" class="accept-input" size='small'>
						<el-option value="0" label="全部"></el-option>
						<el-option v-for="item in lineList" :value="item.lineid" :label="item.linename" :key="item.lineid"></el-option>
					</el-select>
				</div>
				<div class="input-box">
					<span style="display: inline-block;text-indent: 1em;">收货人：</span>
					<el-input
						class="search-input"
						v-model="buyerName"
						placeholder="请输入收货人"
						size="small"
						maxlength="20"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
		</div>
		<div class="filters-box-row filters-box-row2">
			<div class="filters-container" v-show="!collapse">
				<div class="input-box">
					<span>联系方式：</span>
					<el-input
						v-model="buyerTel"
						placeholder="请输入联系电话"
						type="number"
						size="small"
						maxlength="11"
						class="input-tel"
						@keyup.enter.native="search">
					</el-input>
				</div>
				<div class="input-box">
					<span>收货地址：</span>
					<el-input
						v-model="address"
						placeholder="请输入收货地址"
						size="small"
						style="width:345px"
						@keyup.enter.native="search">
					</el-input>
				</div>
				<!-- <div class="input-box" v-if="active === '待发货' && clddock === 1">
					<span>同步云数据：</span>
					<el-select v-model="pushstate" class="filter-input accept-input" size='small'>
						<el-option value="-1" label="全部"></el-option>
						<el-option value="0" label="未同步"></el-option>
						<el-option value="1" label="无法同步"></el-option>
						<el-option value="2" label="同步失败"></el-option>
					</el-select>
				</div> -->
				<div class="input-box" v-if="active !== '待付款' ? (active === '待接单' && needauditingflag ? false : true) : false">
					<span>支付方式：</span>
					<el-select v-model="paymentMode" class="accept-input" size='small'>
						<el-option value="-1" label="全部"></el-option>
						<el-option value="0" label="线下"></el-option>
						<el-option value="2" label="微信支付"></el-option>
						<!-- <el-option value="3" label="支付宝"></el-option>
						<el-option value="4" label="预付货款"></el-option>
						<el-option value="1" label="商龙钱包"></el-option> -->
					</el-select>
				</div>
				<div class="input-box" v-if="active === '待发货'">
					<span>是否申请取消：</span>
					<el-select v-model="cancelMode" class="accept-input" size='small'>
						<el-option value="-1" label="全部"></el-option>
						<el-option value="1" label="申请取消"></el-option>
						<el-option value="0" label="未申请取消"></el-option>
					</el-select>
				</div>
				<!-- <div class="input-box" v-if="active === '已完成'">
					<span>收款状态：</span>
					<el-select v-model="acceptMode" class="filter-input accept-input" size='small'>
						<el-option value="-1" label="全部"></el-option>
						<template v-if="clearing === '1'">
							<el-option value="0" label="未结算"></el-option>
							<el-option value="2" label="结算中"></el-option>
							<el-option value="1" label="已完结"></el-option>
						</template>
						<template v-else>
							<el-option value="0" label="待收款"></el-option>
							<el-option value="2" label="收款中"></el-option>
							<el-option value="1" label="已收款"></el-option>
						</template>
					</el-select>
				</div> -->
				<div class="input-box" v-if="active === '已完成'">
					<span>勾销状态：</span>
					<el-select v-model="liquidateflag" class="accept-input" size='mini'>
						<el-option value="-1" label="全部"></el-option>
						<el-option value="1" label="已勾销"></el-option>
						<el-option value="0" label="未勾销"></el-option>
					</el-select>
				</div>
			</div>
		</div>
		<div class="filters-box-row filters-box-row3">
			<el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px" icon="el-icon-printer" @click="printerEvent">打印</el-button>
			<el-button size="small" type="primary" plain class="btn fx-btn export-btn" style="margin-left: 10px" @click="exportExcel">
				<div></div>
				导出
			</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	components: {
		// Print
	},
	props: {
		active: {
			type: String
		},
		clearing: {
			type: String,
			default: '0'
		},
		origin: {
			type: String,
			default: ''
		},
		clddock: {
			type: Number,
			default: 0
		},
		ids: {
			type: Array,
			default: () => []
		},
		customList: {
			type: Array,
			default: () => []
		},
		lineList: {
			type: Array,
			default: () => []
		},
		needauditingflag: Boolean
	},
	data () {
		return {
			dateValue: [],
			buyerTel: '',
			orderNumber: '',
			keyword: '',
			paymentMode: '-1',
			cancelMode: '-1',
			acceptMode: '-1',
			pushstate: '-1',
			buyerName: '',
			ordersource: '-1',
			liquidateflag: '-1',
			collapse: false,
			dateType: 0,
			customerCategoryId: '0',
			lineId: '0',
			address: '',
			productName: '',
			customerName: ''
		}
	},
	created () {
		if (window.sessionStorage.getItem('orderSelect')) {
			let data = JSON.parse(window.sessionStorage.getItem('orderSelect'))
			this.dateValue = data.dateValue
			this.buyerTel = data.buyerTel
			this.orderNumber = data.orderNumber
			this.keyword = data.keyword
			this.paymentMode = data.paymentMode
			this.buyerName = data.buyerName
			this.acceptMode = data.acceptMode
			this.cancelMode = data.cancelMode
			this.ordersource = data.ordersource
			this.pushstate = data.pushstate
			this.dateType = data.dateType
			this.liquidateflag = data.liquidateflag
			this.customerCategoryId = data.customerCategoryId
			this.lineId = data.lineId
			this.address = data.address
			this.productName = data.productName
			this.customerName = data.customerName
		}
		if (window.sessionStorage.getItem('orderSearchTime')) {
			this.dateValue = JSON.parse(window.sessionStorage.getItem('orderSearchTime'))
		} else {
			if (!this.origin) {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			} else {
				this.dateValue = []
			}
		}
	},
	methods: {
		// 勾销
		liquidate (num) {
			this.$emit('liquidate', num)
		},
		printerEvent () {
			if (this.ids.length < 1) {
				this.$message.error('请至少选择一条订单！')
				return false
			}
			this.$emit('openPrinter')
		},
		searchTime (value) {
			value = [value[0] + ':00', value[1] + ':59']
			window.sessionStorage.setItem('orderSearchTime', JSON.stringify(value))
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于6个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			// if (arr1[0] === arr2[0]) { // 同年
			// 	if (arr2[1] - arr1[1] > 6) { // 月间隔超过6个月
			// 		flag = false
			// 	} else if (arr2[1] - arr1[1] === 6) { // 月相隔6个月，比较日
			// 		if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
			// 			flag = false
			// 		}
			// 	}
			// } else { // 不同年
			if (arr2[0] - arr1[0] > 1) {
				flag = false
			} else if (arr2[0] - arr1[0] === 1) {
				if (arr1[1] < arr2[1]) { // 月相隔大于12个月
					flag = false
				} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			}
			// }
			if (!flag) {
				this.$message.error('时间范围不得超过12个月！')
				return false
			}
			return true
		},
		search () {
			// this.dateValue = this.dateValue === null ? [] : this.dateValue
			console.log(this.dateValue)
			if (this.checkTime()) {
				this.$emit('handleSearch', { customerCategoryId: this.customerCategoryId, lineId: this.lineId, address: this.address, productName: this.productName, customerName: this.customerName, dateValue: this.dateValue, buyerTel: this.buyerTel, liquidateflag: this.liquidateflag, orderNumber: this.orderNumber, keyword: this.keyword, paymentMode: this.paymentMode, ordersource: this.ordersource, buyerName: this.buyerName, cancelMode: this.cancelMode, acceptMode: this.acceptMode, pushstate: this.pushstate, dateType: this.dateType })
			}
		},
		// 导出
		exportExcel () {
			this.$emit('exportExcel')
		},
		clear () {
			let value = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.searchTime(value)
			this.clearAllInput()
			this.search()
		},
		clearInput () {
			this.buyerTel = ''
			this.orderNumber = ''
			this.keyword = ''
			this.paymentMode = '-1'
			this.cancelMode = '-1'
			this.ordersource = '-1'
			this.acceptMode = '-1'
			this.pushstate = '-1'
			this.payMode = '-1'
			this.buyerName = ''
			this.liquidateflag = '-1'
			this.customerCategoryId = '0'
			this.lineId = '0'
			this.address = ''
			this.productName = ''
			this.customerName = ''
		},
		clearAllInput () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			this.buyerTel = ''
			this.orderNumber = ''
			this.keyword = ''
			this.paymentMode = '-1'
			this.ordersource = '-1'
			this.cancelMode = '-1'
			this.acceptMode = '-1'
			this.pushstate = '-1'
			this.payMode = '-1'
			this.buyerName = ''
			this.liquidateflag = '-1'
			this.customerCategoryId = '0'
			this.lineId = '0'
			this.address = ''
			this.productName = ''
			this.customerName = ''
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	padding: 10px 0 0 0;
	width :100%;
	line-height :50px;
	min-width :600px;
	box-sizing: border-box
	text-align: left
	.select-input {
		width: 125px!important;
	}
	.search-input {
		width: 125px!important;
	}
	&.filters-box-row2 {
		padding-top: 0;
		.filters-container {
			display: flex
			flex-wrap: wrap
			.input-box {
				margin-right: 5px
			}
		}
	}
	&.filters-box-row3 {
		padding-top: 5px;
		// border-bottom: 1px solid #dce1fe;
		height: 50px
	}
	.filters-container {
		margin-right: 5px
		.el-input {
			width: 155px
		}
		.time-input {
			width: 300px;
			margin-left: 10px;
		}
		.filter-input {
			width: 155px
		}
		// .cancel-select {
		// 	width: 150px
		// }
		.accept-input {
			width: 125px
		}
		.batch-register-btn{
			cursor :pointer;
			color: var(--fx-primary-color);
			font-size: 12px;
			margin-left: 10px;
			display: inline-block;
			width: 60px;
			height: 40px;
			// position: absolute;
			// left: 10px;
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			vertical-align: sub;
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
}
</style>
<style lang="stylus">
	.export-btn {
		span {
			display: flex;
			align-items: center
			div {
				width: 14px;
				height: 14px;
				margin-right: 5px;
				background-image: url('~images/icon/export-icon.png')
			}
		}
		&:hover {
			div {
				background-image: url('~images/icon/export-white-icon.png')
			}
		}
	}
	.input-tel input{
		-webkit-appearance: none;
		-webkit-box-sizing: content-box;
		font-family: inherit;
		font-size: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
</style>
